const wine = [
  "merlot",
  "orange wine",
  "semillon",
  "savignon blanc",
  "shiraz",
  "viognier",
  "chardonnay",
  "reisling",
  "pinot grigio",
  "pino noir"
]
export default wine;